import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../constants';

/**
 * Accept-Language 헤더에서 콘솔이 지원하는 언어만 선호 순서대로 추출합니다.
 * @description
 * - 헤더의 언어 선호도 순서를 유지하며 중복을 제거합니다
 * - 지원 언어 교집합이 비어 있으면 DEFAULT_LANGUAGE 단일 원소 배열을 반환합니다
 * @example
 * getSupportedBrowserLanguages('ko-KR,ko;q=0.9,en-US;q=0.8,en;q=0.7'); // ['ko', 'en']
 * getSupportedBrowserLanguages('ja,zh-CN;q=0.9'); // ['ko']
 */
export const getSupportedBrowserLanguages = (
  acceptLanguageHeader: string | undefined,
): string[] => {
  if (!acceptLanguageHeader) return [DEFAULT_LANGUAGE];

  const parsed = acceptLanguageHeader
    .split(',')
    .map(chunk => chunk.trim().split(';')[0]?.split('-')[0])
    .filter((lang): lang is string => Boolean(lang));

  const seen = new Set<string>();
  const supported: string[] = [];

  for (const lang of parsed) {
    if (!SUPPORTED_LANGUAGES.includes(lang) || seen.has(lang)) continue;
    seen.add(lang);
    supported.push(lang);
  }

  return supported.length > 0 ? supported : [DEFAULT_LANGUAGE];
};
